module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "ibox-content clearfix"
  }, _vm._l((_vm.channelTypeConfig), function(cfg) {
    return _c('span', {
      key: cfg.title,
      on: {
        "click": function($event) {
          return _vm.connectChannel(cfg.method || cfg.title)
        }
      }
    }, [(_vm.showChannelIcon(cfg.alwaysShow)) ? _c('div', {
      staticClass: "channel-add-item"
    }, [_c('span', {
      staticClass: "fa fa-fw fa-3x channel-logo",
      class: cfg.icon,
      style: (("color: " + (cfg.color)))
    }), _vm._v(" "), _c('span', {
      staticClass: "channel-title"
    }, [_vm._v(_vm._s(cfg.title))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('facebook-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showFacebookCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleFacebookVisibilityChange
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleInstagramVisibilityChange
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleEmailDialogVisibilityChange
    }
  }), _vm._v(" "), _c('wechat-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWechatCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWechatDialogVisibilityChange
    }
  }), _vm._v(" "), _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsAppWebCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWhatsappWebDialogVisibilityChange
    }
  }), _vm._v(" "), _c('telegram-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showTelegramCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleTelegramDialogVisibilityChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Add Channel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_c('p', [_vm._v("\n      A channel is simply a mechanism by which we can get your interactions into the system be it by email,\n      Facebook, WhatsApp, SMS... etc.\n    ")]), _vm._v(" "), _c('p', [_vm._v("Once we get the interaction, that's when the real magic happens! Choose a provider below to connect a new channel.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40396f81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/ChannelCreate.vue
// module id = 3244
// module chunks = 3